export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-v1-960-9e98e04cfd68257ff9f1a6d13b02db22.png";